import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectUnitToken } from '@homeplay/app';
import { apiGetQuickPick } from '@homeplay/api';
import { useCallOnceWhen } from '../../hooks/useCallOnceWhen';
import { useAssistantActions } from '../../hooks/useLottoAssistantContext';
import { LOTTO_CONSTANTS } from '../../constants';
import BetTicketsContainer from '../BetTicketsContainer';
import WidgetError from '../WidgetError';

const QuickPickTickets = ({ intentArgs, messageId, onWidgetDataLoaded }) => {
  const unitToken = useSelector(selectUnitToken);
  const prefetchedData = intentArgs?.data;

  const stake = intentArgs?.stake ?? LOTTO_CONSTANTS.DEFAULT_STAKE;
  const country = intentArgs?.country;
  const lotteryName = intentArgs?.lottery_name;
  const format = intentArgs?.format;

  const [data, setData] = useState(prefetchedData ?? null);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!unitToken) return;
    setError(null);
    try {
      const result = await apiGetQuickPick({
        unitToken,
        stake: stake || LOTTO_CONSTANTS.DEFAULT_STAKE,
        country,
        lotteryName,
        format,
      });
      setData(result);
    } catch (err) {
      setError(err);
    }
  }, [unitToken, stake, country, lotteryName, format]);

  useEffect(() => {
    if (prefetchedData) return;
    fetchData();
  }, [fetchData, prefetchedData]);

  const { trackLottoEvent } = useAssistantActions();
  const tickets = data?.bet_tickets;
  const isDataLoaded = !!data || !!error;
  useCallOnceWhen(isDataLoaded, onWidgetDataLoaded);

  useCallOnceWhen(!!tickets, () => {
    trackLottoEvent('quick_pick', {
      country,
      lottery_name: lotteryName,
      format,
      bet_tickets: tickets.map((ticket) => ({
        ...ticket,
        stake: ticket.stake * LOTTO_CONSTANTS.CENTS_MULTIPLIER,
      })),
    });
  });

  if (!prefetchedData && error) {
    return <WidgetError onRetry={fetchData} error={error} />;
  }

  return <BetTicketsContainer tickets={tickets ?? []} messageId={messageId} />;
};

export default QuickPickTickets;
